import React, { useEffect, useState } from 'react';
import { styled } from '@mui/system';
import { removeVietnameseTones } from '@/utils/stringConvert';
import { style } from '@/styles/globals';
import { useAppDispatch, useAppSelector } from '@/utils/hook';
import { setHeaderTab } from '@/slices/menu/menuSlices';

interface MenuBarProps {
  data: any,
}

const MenuBar = (props: MenuBarProps) => {
  const { data } = props;
  const [nextAnchor, setNextAnchor] = useState('');
  const dispatch = useAppDispatch();
  const headerTab = useAppSelector((state) => state.menu.headerTab);

  useEffect(() => {
    dispatch(setHeaderTab('tim-chuyen'));
  }, []);

  useEffect(() => {
    if (headerTab.includes(nextAnchor) && !headerTab.includes(':first')) {
      setNextAnchor('');
    }
  }, [headerTab]);

  return (
    <ScrollistStyle
      className="nav"
    >
      {data.map((item: any) => {
        const labelCode = removeVietnameseTones(item.label.replace(/ /g, '-').toLowerCase());
        const href = `#${labelCode}`;
        return (
          <CustomTagA
            onClick={() => {
              setNextAnchor(labelCode);
              dispatch(setHeaderTab(`${labelCode}:first`));
            }}
            key={labelCode}
            active={(nextAnchor.split(':first')[0] || headerTab) === labelCode}
            href={href}
          >
            {item.label}
          </CustomTagA>
        );
      })}
    </ScrollistStyle>
  );
};

const ScrollistStyle = styled<any>('div')`
  display: flex;
  height: fit-content;
  background: #ffffff;
  padding-left:4px;
  height:44px;
  padding:0 8px 8px 16px;

  
`;

const CustomTagA = styled<any>('a')`
  flex-shrink: 0;
  color: #000;
  padding: 16px;
  text-decoration: none;

  border-bottom:${(props) => (props.active ? `2px solid ${style.color.product2}` : 'none')} ;
  color:${(props) => (props.active ? style.color.product3 : style.color.black4)} ;
  font-weight :${(props) => (props.active ? 700 : 400)} ;
`;

export default MenuBar;
